module.exports = __webpack_public_path__ + "static/media/alexa-firebase.4dd70492.png";